// Global Instructions Rule Applied!

import React, { useMemo } from 'react'
import TableView from '../../../core/components/TableView/TableView.tsx'
import { createTableColumns } from '../../../ui_configs/table_grid_columns.ts'
import type { ViewConfigColumn } from '../../../core/components/ViewConfig/types.ts'

interface CashFlowsTableProps {
  data: Record<string, unknown>[]
  loading: boolean
  gridColumns: ViewConfigColumn[]
}

export const CashFlowsTable = React.memo(function CashFlowsTable({
  data,
  loading,
  gridColumns
}: CashFlowsTableProps) {
  const configs = useMemo(() => gridColumns, [gridColumns])

  const { columns, frozenColumns } = useMemo(() => {
    return createTableColumns({
      columns: configs,
      fallbackRecordModuleKey: 'cash_flows'
    })
  }, [configs])

  const dataSource = useMemo(() => {
    const src = data ?? []
    return src.map((row, i) => {
      const id = [
        row.up_tranches__id ?? '',
        row.asset_transactions__name ?? '',
        row.transaction_date ?? '',
        row.cfg_asset_transaction_types__label ?? '',
        i
      ].join('-')
      return {
        ...row,
        id,
        key: id
      }
    })
  }, [data])

  if (columns.length === 0) return null

  return (
    <div className='flex-1 min-h-0 h-full w-full'>
      <TableView
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        frozenColumns={frozenColumns}
        headerStyle={{ padding: '5px', minHeight: 40, backgroundColor: '#f5f5f5' }}
      />
    </div>
  )
})
